import React, {Component} from 'react'
import Base from '../BaseComponent'
import Content from '../Content'
import {
  Link
} from 'react-router-dom';

import { withGoogleMap, GoogleMap, Marker } from "react-google-maps"

// global map styles
const mapStyles = require("../../utils/mapStyles.json");


class MiniMap extends Component {


  render () {

  	// SVG marker icon
  	const icon = {
	    path: "M0,15.93H3.93L1.17,0,6,4.43,10.8,0,8.13,15.93H12l-6,8.4Z",
	    fillColor: '#FFC03B',
	    fillOpacity: 1,
	    strokeWeight: 0,
	    scale: 1
	}

	//position object from props
	const latlng = {
		lat: parseFloat(this.props.lng),
		lng: parseFloat(this.props.lat)
	}

  	

  	const MyMapComponent = withGoogleMap((props) =>
		  <GoogleMap
		    defaultZoom={16}
		    defaultCenter={latlng}
		    defaultOptions={{ styles: mapStyles, disableDefaultUI: true}}>
		    	<Marker position={latlng} icon={icon} />
		  </GoogleMap>
		)



    return (

      <Base {...this.props} className="MiniMap">

      	<MyMapComponent
			  isMarkerShown
			  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDDLRWpVufzuhIhNq9NS_0r0BSHfbZ8oIU&v=3.exp&libraries=geometry,drawing,places"
			  loadingElement={<div style={{ width: '100%', height: `100%` }} />}
			  containerElement={<div style={{ width: '100%', height: `400px` }} />}
			  mapElement={<div style={{ width: '100%', height: `100%` }} />}
			/>


			<Content modifier={'yellow'}>
				<h4><Link to={'https://www.google.com/maps/?q=' + latlng.lat + ',' + latlng.lng} target="_blank">View on Google Maps</Link></h4>
        	</Content>
      </Base>
    )
  }
}

export default MiniMap



// WEBPACK FOOTER //
// ./src/js/components/MiniMap/MiniMap.jsx